import { Field } from '@base-ui/react/field'

import { HEX_COLOR } from '@/lib/validators'

import type { FieldProps } from './field-props'
import { Input } from './input'

export function ColorField({
  ref,
  ariaLabel,
  hideLabel = false,
  name,
  label,
  hint,
  placeholder,
  value,
  error,
  disabled,
  describedBy,
  onChange,
  onBlur,
}: FieldProps) {
  const pickerValue = HEX_COLOR.test(value) ? value : '#000000'

  return (
    <Field.Root name={name} data-slot="color-field" className="flex flex-col gap-1.5">
      <Field.Label className={hideLabel ? 'sr-only' : 'text-xs font-medium'}>{ariaLabel ?? label}</Field.Label>
      <div className="border-input bg-input/20 focus-within:border-ring focus-within:ring-ring/30 dark:bg-input/30 flex h-8 items-center gap-2 rounded-md border px-1.5 focus-within:ring-2">
        <span aria-hidden="true" className="text-muted-foreground shrink-0 pl-1 font-mono">#</span>
        <Field.Control
          ref={ref}
          aria-label={ariaLabel}
          value={(value ?? '').replace(/^#/, '')}
          placeholder={placeholder}
          disabled={disabled}
          aria-describedby={describedBy}
          aria-invalid={error !== undefined ? true : undefined}
          onChange={(event) => {
            const hex = event.target.value.replace(/^#/, '')
            onChange(hex === '' ? '' : `#${hex}`)
          }}
          onBlur={onBlur}
          render={
            <Input className="h-6 border-0 bg-transparent px-1 font-mono uppercase shadow-none focus-visible:ring-0 dark:bg-transparent" />
          }
        />
        <input
          type="color"
          aria-label={`${ariaLabel ?? label} color picker`}
          value={pickerValue}
          disabled={disabled}
          className="size-5 shrink-0 cursor-pointer overflow-hidden rounded-full border border-border bg-transparent p-0 disabled:cursor-not-allowed [&::-moz-color-swatch]:rounded-full [&::-moz-color-swatch]:border-0 [&::-webkit-color-swatch-wrapper]:p-0 [&::-webkit-color-swatch]:rounded-full [&::-webkit-color-swatch]:border-0"
          onChange={(event) => onChange(event.target.value.toUpperCase())}
          onBlur={onBlur}
        />
      </div>
      {hint && <Field.Description className="text-muted-foreground text-xs">{hint}</Field.Description>}
      <Field.Error match={error !== undefined} role="alert" className="text-destructive text-xs">
        {error}
      </Field.Error>
    </Field.Root>
  )
}
